import { AbstractAttributeCell, AttributeCellProps } from './AbstractAttributeCell';

interface CellProps extends AttributeCellProps {
    title?: string
    hideTitle?: boolean
}

export class AttributeCell extends AbstractAttributeCell<CellProps> {
    protected renderInner(): JSX.Element | null | undefined {
        const props = this.props;
        const attr = props.attr;
        const title = !props.hideTitle ? this.getTitle(props.title, attr) : undefined;
        const product = props.product;

        // Display the `children` as content if given
        const content = this.buildContent(props, product, attr, title);
        if (content || !props.hideEmpty) {
            return this.link(content);
        } else {
            return null;
        }
    }
}
